import { useEffect } from 'react';

import { useEnrolUser } from '@justgiving/experiments';

import { Experiments } from '../../constants/experiments';
import { MODAL } from '../../context';
import { useApp } from '../useApp';
import { usePageOwner } from '../usePageOwner';

interface UseOpenDonateToYourselfModal {
  totalDonationAmount?: number;
}

export function useOpenDonateToYourselfModal({
  totalDonationAmount,
}: UseOpenDonateToYourselfModal) {
  const { isPageOwner } = usePageOwner();

  // B2C_059 - donate to yourself v3
  // Can be removed when experiment has ended
  const isNotOwnerOrPageIsActivated =
    !isPageOwner ||
    totalDonationAmount === undefined ||
    totalDonationAmount > 0;

  const { enrolledIn } = useEnrolUser(
    Experiments.b2c_059_donate_to_yourself_v3,
    isNotOwnerOrPageIsActivated,
  );

  const { showModal } = useApp();
  const urlParams = new URLSearchParams(
    typeof window !== 'undefined' ? window.location.search : '',
  );
  const isNewPage = Boolean(urlParams.get('newPage'));

  const isNotOwnerOrNewPage = !isPageOwner || !isNewPage;

  useEffect(() => {
    if (enrolledIn === undefined || enrolledIn === 'A') {
      if (isNotOwnerOrNewPage) return;

      showModal({ modal: MODAL.DONATE_TO_YOURSELF });
    }

    // If we are enrolled in B we know for certain that the page meets
    // the enrolment criteria due to the skip enrolment condition
    if (enrolledIn === 'B') {
      showModal({ modal: MODAL.DONATE_TO_YOURSELF });
    }
  }, [isNotOwnerOrNewPage, showModal, enrolledIn]);
}
